import { createContextValues } from '@connectrpc/connect';
import { type CreateEphemeralDashboardTokenRequest } from '@qdrant/qdrant-cloud-public-api/cluster/auth/v1/ephemeral_dashboard_token';
import { createEphemeralDashboardToken } from '@qdrant/qdrant-cloud-public-api/cluster/auth/v1/ephemeral_dashboard_token/connect-query';
import { type QueryClient } from '@tanstack/react-query';
import { type MessageInput, useMutation, type MutationFactory } from '@/connect-query';
import { ctxKeyQueryClient } from '@/connect-query/context-keys';
import { transport } from '../transport';

export const useCreateEphemeralDashboardTokenMutation: MutationFactory<typeof createEphemeralDashboardToken> = (
  options,
) => useMutation(createEphemeralDashboardToken, options);

export const createEphemeralDashboardTokenFn = async ({
  client,
  accountId,
  clusterId,
}: { client: QueryClient } & MessageInput<CreateEphemeralDashboardTokenRequest>) => {
  const { message } = await transport.unary(
    createEphemeralDashboardToken,
    undefined,
    undefined,
    undefined,
    { accountId, clusterId },
    createContextValues().set(ctxKeyQueryClient, client),
  );
  return message;
};
